module.exports = __webpack_public_path__ + "static/media/close.5b842cd7.png";